var map = {
	"./10.5mm.svg": 83820,
	"./10mm.svg": 14151,
	"./11mm.svg": 54402,
	"./5.5mm.svg": 20278,
	"./5mm.svg": 82653,
	"./6.5mm.svg": 99441,
	"./6mm.svg": 22518,
	"./7.5mm.svg": 69840,
	"./7mm.svg": 75963,
	"./8.5mm.svg": 45243,
	"./8mm.svg": 60780,
	"./9.5mm.svg": 51250,
	"./9mm.svg": 65977,
	"./display.svg": 8088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82514;